import React, { useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import MultiSelect from "components/common/MultiSelect";
import BootDatePicker from "components/common/custom/forms/BootDatePicker/index.jsx";
import { handleClaimPollsFilter } from "../config/ClaimPollsSlice";

const ClaimPollsFilter = ({ control, watch, setValue, clearErrors, errors, isSubmitted }) => {
    const dispatch = useDispatch();
    const { userData } = useSelector((state) => state.auth);
    const { claimPollsFilter } = useSelector((state) => state.claimPolls);
    const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];

    const handleBranch = (selected) => {
        if (!selected) {
            setValue("branch_id", null);
            dispatch(handleClaimPollsFilter({ check: "branch_id", value: null }));
            return;
        }
        const value = {
            branch_name: selected.label,
            branch_id: selected.value,
        };
        setValue("branch_id", value);
        dispatch(handleClaimPollsFilter({ check: "branch_id", value }));
        clearErrors("branch_id");
    };

    const handlePollsType = (selected) => {
        if (!selected) {
            setValue("polls_type", null);
            dispatch(handleClaimPollsFilter({ check: "polls_type", value: null }));
            return;
        }
        setValue("polls_type", selected);
        dispatch(handleClaimPollsFilter({ check: "polls_type", value: selected }));
        clearErrors("polls_type");
    };

    const handleStartDate = (date) => {
        setValue("start_date", date);
        dispatch(handleClaimPollsFilter({ check: "start_date", value: date }));
        clearErrors("start_date");
    };

    const handleEndDate = (date) => {
        setValue("end_date", date);
        dispatch(handleClaimPollsFilter({ check: "end_date", value: date }));
        clearErrors("end_date");
    };

    useEffect(() => {
        if (claimPollsFilter) {
            setValue("branch_id", claimPollsFilter.branch_id);
            setValue("polls_type", claimPollsFilter.polls_type);
            setValue("start_date", claimPollsFilter.start_date);
            setValue("end_date", claimPollsFilter.end_date);
        }
    }, []);

    return (
        <Row className="align-items-center">
            {userData?.employee?.syspri_id === 1 && (
                <Col xs={12} sm={6} md={3} xl={2}>
                    <label className="form-label">Branch <span className="text-danger">*</span></label>
                    <Controller
                        name="branch_id"
                        control={control}
                        rules={{ required: "Branch is required" }}
                        render={({ field }) => (
                            <MultiSelect
                                {...field}
                                errors={errors}
                                isMulti={false}
                                options={allBranches?.map((item) => ({
                                    value: item.branch_id,
                                    label: item.branch_name,
                                }))}
                                isClearable={true}
                                placeholder="Choose ..."
                                value={field.value ? { value: field.value.branch_id, label: field.value.branch_name } : null}
                                onChange={handleBranch}
                            />
                        )}
                    />
                </Col>
            )}

            <Col xs={12} sm={6} md={3} xl={2}>
                <Form.Group>
                    <Form.Label>Poll Type <span className="text-danger">*</span></Form.Label>
                    <Controller
                        name="polls_type"
                        control={control}
                        rules={{ required: "Poll Type is required" }}
                        render={({ field }) => (
                            <MultiSelect
                                {...field}
                                errors={errors}
                                isMulti={false}
                                options={[
                                    { value: "Preauthorization", label: "Preauthorization" },
                                    { value: "Claim", label: "Claim" },
                                    { value: "Payment", label: "Payment" },
                                    { value: "Advance Preauthorization", label: "Advance Preauthorization" },
                                ]}
                                isClearable={true}
                                placeholder="Choose ..."
                                value={field.value}
                                onChange={handlePollsType}
                            />
                        )}
                    />
                </Form.Group>
            </Col>

            <Col xs={12} sm={6} md={3} xl={2}>
                <BootDatePicker
                    name="start_date"
                    label="Start Date"
                    size="sm"
                    control={control}
                    errors={errors}
                    isRequired={true}
                    rules={{ required: "Start date is required" }}
                    selected={watch("start_date")}
                    onChange={handleStartDate}
                    placeholder="dd/mm/yyyy"
                />
            </Col>

            <Col xs={12} sm={6} md={3} xl={2}>
                <BootDatePicker
                    name="end_date"
                    label="End Date"
                    size="sm"
                    control={control}
                    errors={errors}
                    isRequired={true}
                    rules={{ required: "End date is required" }}
                    selected={watch("end_date")}
                    onChange={handleEndDate}
                    placeholder="dd/mm/yyyy"
                />
            </Col>
        </Row>
    );
};

export default ClaimPollsFilter;